module.exports = __webpack_public_path__ + "files/aaa6123dfae011599bf03d510f991599.png";